import {
  SAVE_HED_ACTIVITY_START,
  SAVE_HED_ACTIVITY_SUCCESS,
  SAVE_HED_ACTIVITY_FAIL,
  SET_HED_SPECIAL_GRADE_START,
  SET_HED_SPECIAL_GRADE_SUCCESS,
  SET_HED_SPECIAL_GRADE_FAIL,
  CLEAR_HED_SPECIAL_GRADE_START,
  CLEAR_HED_SPECIAL_GRADE_SUCCESS,
  CLEAR_HED_SPECIAL_GRADE_FAIL,
  INIT_HED_GRADE_COMPONENTS_START,
  INIT_HED_GRADE_COMPONENTS_SUCCESS,
  INIT_HED_GRADE_COMPONENTS_FAIL,
  LOCK_HED_GRADES_START,
  LOCK_HED_GRADES_SUCCESS,
  LOCK_HED_GRADES_FAIL,
  UNLOCK_HED_GRADES_START,
  UNLOCK_HED_GRADES_SUCCESS,
  UNLOCK_HED_GRADES_FAIL,
  REVIEW_GRADE_SUBMISSION_START,
  REVIEW_GRADE_SUBMISSION_SUCCESS,
  REVIEW_GRADE_SUBMISSION_FAIL,
  RESOLVE_HED_TBA_START,
  RESOLVE_HED_TBA_SUCCESS,
  RESOLVE_HED_TBA_FAIL,
} from "./actions";

const initState = {
  // Activity save / score input
  saving: false,
  saved: false,
  saveError: null,
  // Grade component initialization
  initializing: false,
  initialized: false,
  initError: null,
  // Special grade override (INC/DRP)
  settingSpecial: false,
  setSpecial: false,
  setSpecialError: null,
  // Special grade clear
  clearingSpecial: false,
  clearedSpecial: false,
  clearSpecialError: null,
  // Grade locking
  locking: false,
  locked: false,
  lockError: null,
  unlocking: false,
  unlockError: null,
  // Grade submission review
  reviewingSubmission: false,
  reviewSubmissionError: null,
  // TBA resolution
  resolvingTba: false,
  resolvingTbaError: null,
};

const heClassReducer = (state = initState, action) => {
  switch (action.type) {
    case SAVE_HED_ACTIVITY_START:
      return { ...state, saving: true, saved: false, saveError: null };
    case SAVE_HED_ACTIVITY_SUCCESS:
      return { ...state, saving: false, saved: true };
    case SAVE_HED_ACTIVITY_FAIL:
      return { ...state, saving: false, saved: false, saveError: action.error };

    case INIT_HED_GRADE_COMPONENTS_START:
      return { ...state, initializing: true, initialized: false, initError: null };
    case INIT_HED_GRADE_COMPONENTS_SUCCESS:
      return { ...state, initializing: false, initialized: true };
    case INIT_HED_GRADE_COMPONENTS_FAIL:
      return { ...state, initializing: false, initError: action.error };

    case SET_HED_SPECIAL_GRADE_START:
      return { ...state, settingSpecial: true, setSpecial: false, setSpecialError: null };
    case SET_HED_SPECIAL_GRADE_SUCCESS:
      return { ...state, settingSpecial: false, setSpecial: true };
    case SET_HED_SPECIAL_GRADE_FAIL:
      return { ...state, settingSpecial: false, setSpecialError: action.error };

    case CLEAR_HED_SPECIAL_GRADE_START:
      return { ...state, clearingSpecial: true, clearedSpecial: false, clearSpecialError: null };
    case CLEAR_HED_SPECIAL_GRADE_SUCCESS:
      return { ...state, clearingSpecial: false, clearedSpecial: true };
    case CLEAR_HED_SPECIAL_GRADE_FAIL:
      return { ...state, clearingSpecial: false, clearSpecialError: action.error };

    case LOCK_HED_GRADES_START:
      return { ...state, locking: true, locked: false, lockError: null };
    case LOCK_HED_GRADES_SUCCESS:
      return { ...state, locking: false, locked: true };
    case LOCK_HED_GRADES_FAIL:
      return { ...state, locking: false, lockError: action.error };

    case UNLOCK_HED_GRADES_START:
      return { ...state, unlocking: true, unlockError: null };
    case UNLOCK_HED_GRADES_SUCCESS:
      return { ...state, unlocking: false };
    case UNLOCK_HED_GRADES_FAIL:
      return { ...state, unlocking: false, unlockError: action.error };

    case RESOLVE_HED_TBA_START:
      return { ...state, resolvingTba: true, resolvingTbaError: null };
    case RESOLVE_HED_TBA_SUCCESS:
      return { ...state, resolvingTba: false };
    case RESOLVE_HED_TBA_FAIL:
      return { ...state, resolvingTba: false, resolvingTbaError: action.error };

    case REVIEW_GRADE_SUBMISSION_START:
      return { ...state, reviewingSubmission: true, reviewSubmissionError: null };
    case REVIEW_GRADE_SUBMISSION_SUCCESS:
      return { ...state, reviewingSubmission: false };
    case REVIEW_GRADE_SUBMISSION_FAIL:
      return { ...state, reviewingSubmission: false, reviewSubmissionError: action.error };

    default:
      return state;
  }
};

export default heClassReducer;
